
<template>
    <div class="passport__item" v-if="fileInfo">
        <label for="" class="form-label">{{ title }}</label>
        <div class="passport__view">
            <img :src="getNameOfPhoto(fileInfo.file_path)"  alt="Passport">
        </div>
        <a
            @click="$refs.imageInput.click()"
            href="javascript:void(0)"
            class="passport__link">Change/
        </a>
        <a
            @click="deleteFile"
            href="javascript:void(0)"
            class="passport__link">Delete
        </a>
        <input
            type="file"
            style="display: none"
            @change="onImageSelected"
            ref="imageInput"
            accept="image/*"
            size="10mb"
        >
    </div>
    <div class="passport__item" v-else>
        <label for="" class="form-label">{{ title}}</label>
        <div class="passport__box">
            <a
                href="javascript:void(0)"
               @click="$refs.imageInput.click()"
               class="btn">
                <i class="fa-solid fa-upload"></i>
                Upload
            </a>
            <p>Max 10 MB in .jpg/.png format</p>
        </div>
        <input
            type="file"
            style="display: none"
            @change="onImageSelected"
            ref="imageInput"
            accept="image/*"
        >
    </div>

</template>

<script>
import {mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import ArtistService from "../../services/ArtistService";

export default {
    name: 'PhotoDocumentContainer',
    emits: ['update-photo'],
    props: {
        title: String,
        field: String,
        file: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            selectedFile: null,
            fileInfo: this.file,
        }
    },
    computed: {
        ...mapState(useArtistStore, {
            artistId: 'artistId',
        })
    },
    watch: {
        file(val) {
            if (val) {
                this.fileInfo = val
                this.$emit('update-photo', this.field, this.fileInfo)
            }
        }
    },
    methods: {
        deleteFile() {
            this.fileInfo = null
            this.$emit('update-photo', this.field, null)
        },
        onImageSelected(event) {
            const file = event.target.files[0];
            const maxSize = 2 * 1024 * 1024;

            if (file && file.size > maxSize) {
                this.$showErrorMessage("Available file size - 2 MB");
                this.$refs.imageInput.value = "";
                return;
            }
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.selectedFile = file;
                    this.uploadPhoto();
                };
                reader.readAsDataURL(file);
            }
        },
        getNameOfPhoto(photo) {
            return photo ? `/uploads/${photo}` : "/img/svg/avatar.svg";
        },
        async uploadPhoto() {
            if (this.selectedFile) {
                this.$showLoadingMessage()
                let formData = new FormData();
                formData.append('file', this.selectedFile);
                try {
                    const response = await ArtistService.uploadDocumentPhoto(this.artistId, formData);
                    this.fileInfo = response.data
                    this.$emit('update-photo', this.field, response.data)
                    this.$showSuccessMessage('The photo was uploaded')
                } catch (e) {
                    console.error(e);
                    this.$showErrorMessage("The photo was not uploaded");
                }
            } else {
                this.$showErrorMessage("Please select photo");
            }
        },
    }

}

</script>

<style scoped>

</style>
